/**
 * Labstep
 *
 * @module components/Layout/RightPane/Index
 * @desc Index of all Right Pane subpages
 */

import { ElementCard } from 'labstep-web/core/Card/Element';
import { Icon } from 'labstep-web/core/Icon';
import LinkButton from 'labstep-web/core/Link/Button';
import { List } from 'labstep-web/core/List';
import { PremiumFeatureLockIcon } from 'labstep-web/core/PremiumFeature/LockIcon';
import { TextWithCount } from 'labstep-web/core/Text/WithCount';
import type React from 'react';
import { RightPaneSubPage } from '../SubPage';
import styles from './styles.module.scss';
import type { RightPaneIndexProps } from './types';

export const RightPaneIndex: React.FC<RightPaneIndexProps> = ({
  subPages,
  desktop,
}) =>
  desktop ? (
    <RightPaneSubPage desktop>
      <List data-testid="right-pane-index-list">
        {subPages.map((page) => (
          <LinkButton key={page.name} route={page.route}>
            <ElementCard
              dataCy={`components/Layout/RightPane/IndexPage:${page.name}`}
              icon={page.icon}
              name={
                <>
                  <TextWithCount
                    text={page.name}
                    count={page.count}
                  />
                  {page.premiumFeature && (
                    <PremiumFeatureLockIcon
                      premiumFeature={page.premiumFeature}
                    />
                  )}
                </>
              }
              right={<Icon name="angle right" size="large" />}
            />
          </LinkButton>
        ))}
      </List>
    </RightPaneSubPage>
  ) : (
    <div className={styles.mobileMenu}>
      {subPages.map((page) => (
        <LinkButton key={page.name} route={page.route}>
          <Icon name={page.icon} />
        </LinkButton>
      ))}
    </div>
  );
